// Formata um valor inteiro em CENTAVOS para BRL no padrão brasileiro:
// separador de milhar "." e decimal ",". Ex.: 320000 -> "R$ 3.200,00".
const formatCentsBRL = cents => {
  const rounded = Math.round(cents || 0);
  const sign = rounded < 0 ? "-" : "";
  const abs = Math.abs(rounded);
  const reais = Math.floor(abs / 100)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const dec = (abs % 100).toString().padStart(2, "0");
  return `${sign}R$ ${reais},${dec}`;
};

const intToBRL = (value, rawValue = false) => {
  if (!value && !rawValue) return "Valor sob consulta";
  return formatCentsBRL(value);
};

const centsToBRL = value => formatCentsBRL(value);

export { intToBRL, centsToBRL };
